/**
 * Data layer for `score-based-routing-fraud-score-auto-allow-flag-bl`. Thin typed fetch wrappers over /api/v1/score-based-routing-fraud-score-auto-allow-flag-bl.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListScoreBasedRoutingFraudScoreAutoAllowFlagBlResponse {
	count: number;
	items: ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow[];
}

export interface CreateScoreBasedRoutingFraudScoreAutoAllowFlagBlBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/score-based-routing-fraud-score-auto-allow-flag-bl";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListScoreBasedRoutingFraudScoreAutoAllowFlagBlResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListScoreBasedRoutingFraudScoreAutoAllowFlagBlResponse>(res);
}

export async function create(body: CreateScoreBasedRoutingFraudScoreAutoAllowFlagBlBody): Promise<ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys = {
	all: ["score-based-routing-fraud-score-auto-allow-flag-bl"] as const,
	list: () => [...scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys.all] as const,
	detail: (id: string) => [...scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys.all, id] as const,
};
